import styled from 'styled-components';

export const QuickFormContainer = styled.div`
      display: ${(props) => (props.show ? 'block' : 'none')};
      position: fixed;
      bottom: 20px;
      width: 420px;
      right: 20px;
      z-index: 999999;
      background-color: white;
      box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
      border-radius: 20px;
      padding: 20px;
      overflow: hidden;

      .btn-close {
            position: absolute;
            background-color: ${(props) => props.theme.primaryColor};
            top: 0;
            right: 0;
            font-size: 20px;
            padding: 12px 20px;
            --bs-btn-close-opacity: 1;
            --bs-btn-close-color: '#FFF';
            border-bottom-left-radius: 20px;
            border-top-left-radius: 0;
            border-bottom-right-radius: 0;
            --bs-btn-close-bg: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23FFF'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e");
      }

      .form-label {
            font-weight: 600;
            letter-spacing: 1px;
      }

      @media only screen and (max-width: 1224px) {
            display: none;
      }
`;
